import { PacemEventTarget, Utils } from '@pacem/pacem-core';
const JPEG_QUALITY = .9;
export class Pacem2DAdapterElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this.DefaultShapeValues = {
            stroke: "#000",
            lineWidth: 1,
            fill: "#fff"
        };
    }
    snapshotElement(element, bgColor, type, quality) {
        const jpeg = !Utils.isNullOrEmpty(bgColor), mime = type ?? (jpeg ? 'image/jpeg' : null), compression = quality ?? (jpeg ? JPEG_QUALITY : null);
        return Utils.snapshotElement(element, bgColor, mime, compression);
    }
}
